export default "__VITE_ASSET__skBxROfB__"